export default __webpack_public_path__ + "static/media/grid-white.dd2d3da6.png";